import classNames from 'classnames';

import { ToolbarSectionTitle } from '@/ui/index';
import { CloseSquare } from '@/icons/index';
import { ToolbarBanner } from '@/components/number-sale/ToolbarBanner';

import Service from './components/Service/Service';
import { InternetBlock } from '../../tariffs';

import styles from './ToolBar.module.scss';

const ToolBar = ({ active, setActive, data }) => {
  const onClose = (event) => {
    const { target } = event;
    if (target.classList.contains('toolbar-target')) {
      setActive(false);
    }
  };

  const renderToolBar = (item, index) => {
    return (
      <div
        key={index}
        className={styles.mt_2}
        itemScope
        itemType='https://schema.org/Thing'
      >
        <ToolbarSectionTitle icon={item?.icon}>
          {item?.title}
        </ToolbarSectionTitle>
        <div className={styles.grid}>
          {item?.links?.map((link, index) => (
            <Service onClick={() => setActive(false)} data={link} key={index} />
          ))}
        </div>
      </div>
    );
  };

  const renderBanner = (item, index) => {
    return (
      <InternetBlock
        contentData={item}
        nonDesktop
        key={index}
        itemScope
        itemType='https://schema.org/Offer'
      />
    );
  };

  return (
    <div
      onClick={onClose}
      className={classNames([
        styles.wrapper,
        { [styles.active]: active },
        'toolbar-target',
      ])}
      itemScope
      itemType='https://schema.org/WebPage'
    >
      <nav className={styles.container}>
        <div className={styles.header}>
          <span className={styles.title}>{data?.title}</span>
          <button
            className={styles.close}
            onClick={() => setActive(false)}
            aria-label='Bakcell'
          >
            <CloseSquare />
          </button>
        </div>
        {data?.sections?.map(renderToolBar)}
        {data?.banners?.map(renderBanner)}
        {/* <ToolbarBanner setActive={setActive} /> */}
      </nav>
    </div>
  );
};

export default ToolBar;
